export const getContainer = (container: HTMLScriptElement, namespace: string): Element => {
    const parent = container.parentNode || document;

    const existing = parent.querySelector(`[data-react-component~="${namespace}"]`);
    if (existing) {
        return existing;
    }

    const reactContainer = document.createElement('div');

    reactContainer.setAttribute('data-react-component', namespace);
    parent.insertBefore(reactContainer, container);
    return reactContainer;
};

const isBlank = (input: string) => {
    return /^\s*$/.test(input);
};

export const getStringOrUndefined = (input: string | undefined): string | undefined => {
    if (!input || isBlank(input)) {
        return undefined;
    }
    return input;
};

const getExternalConfig = <T>(container: HTMLScriptElement): T | undefined => {
    try {
        const configReference = container.getAttribute('data-config-reference');
        if (!configReference) {
            return undefined;
        }
        const configContainer = document.querySelector(`script[data-config-id="${configReference}"]`) as
            | HTMLScriptElement
            | undefined;
        const configContent = getStringOrUndefined(configContainer?.innerText);
        if (configContent) {
            return JSON.parse(configContent);
        }
        return undefined;
    } catch (e) {
        console.warn('Failed to parse external config', e);
        return undefined;
    }
};

const getLocalConfig = <T>(container: HTMLScriptElement): T => {
    try {
        const configText = getStringOrUndefined(container.innerText);
        return configText ? JSON.parse(configText) : ({} as T);
    } catch (e) {
        console.warn('Failed to parse local config', e);
        return {} as T;
    }
};

export const getConfig = <T>(container: HTMLScriptElement): T => {
    try {
        return getExternalConfig<T>(container) ?? getLocalConfig<T>(container);
    } catch (e) {
        console.warn('Failed to parse config', e);
        return {} as T;
    }
};
